export const enforcer = (
  target: HTMLInputElement,
  setValue: React.Dispatch<React.SetStateAction<string>>,
): void => {
  setValue(target.value === '1' ? '1' : '')
}
